module.exports = __webpack_public_path__ + "static/img/Ser.fabdf15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Ser.png
// module id = eVUp
// module chunks = 0